import { MarketingStory } from '@@types'
import { gql, useQuery } from '@apollo/client'

type AllMarketingStoriesData = {
  allMarketingStories: {
    edges: MarketingStory[]
  }
}

type AllMarketingStoriesVariables = {
  style?: string
  imageStyle2?: string
}

export const GQL_QUERY_ALL_MARKETING_STORIES = gql`
  query allMarketingStories($style: String, $imageStyle2: String) {
    allMarketingStories {
      edges {
        id
        name
        preview(style: $style) {
          url
        }
        slides {
          id
          name
          image(style: $imageStyle2) {
            url
          }
          url
          optionOpenInBrowser
          optionOpenInNewWindow
          optionUrl
        }
      }
    }
  }
`

export const useAllMarketingStories = (variables?: AllMarketingStoriesVariables) => {
  const { data, loading, error, refetch } = useQuery<AllMarketingStoriesData, AllMarketingStoriesVariables>(
    GQL_QUERY_ALL_MARKETING_STORIES,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )

  const stories = data?.allMarketingStories?.edges ?? []

  return {
    stories,
    data,
    loading,
    error,
    refetch
  }
}
